import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TextService } from '@app/core/services/text.service';
import { AuthService } from '@app/core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-auth-header',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.scss'
})
export class AuthHeaderComponent {
  textData = toSignal(inject(TextService).text$);
  environment = environment;

  private authService = inject(AuthService);
  private router = inject(Router);

  get isBusiness(): boolean {
    return this.router.url.startsWith('/signup') &&
      this.authService.originDomainData?.source === 'business';
  }

  readonly companyLogos = [1, 2, 3, 4, 5, 6];
}
